// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'scale-down';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m17.438.561-6.75 6.75m-3.375 8.437v-5.062H2.25m8.438-8.437V7.31h5.062m-8.437 3.376-6.75 6.75'
  />
);

export const viewBox = '0 0 18 18';
